import { Tooltip } from '@3pc/tooltip';
import { $$ } from 'src/shared/js/utils/dom';

// Abbreviations
const abbreviations = $$('.abbreviation');
const abbreviationTooltips = [];
let abbreviationTooltip = null;

abbreviations.forEach(element => {
  abbreviationTooltip = new Tooltip(element, {
    contentSelector: '.abbreviation__tooltip',
  });

  abbreviationTooltip.init();
  abbreviationTooltips.push(abbreviationTooltip);
});

export { abbreviationTooltips };
